module.exports = __webpack_public_path__ + "images/emoji/truck.3785dc4add43b434f52d.png";